<ng-select
  class="ng-select-advanced-dialog"
  [ngClass]="cssClass"
  [formControl]="selectControl"
  [multiple]="multiple"
  [closeOnSelect]="!multiple"
  [items]="options"
  [searchable]="false"
  [bindLabel]="bindLabel"
  [bindValue]="bindValue"
  [placeholder]="placeholder"
  [clearable]="clearable"
  [appendTo]="appendTo"
  [dropdownPosition]="dropdownPosition"
  [loading]="loading"
  [attr.aria-label]="placeholder"
  (open)="handleOpen()"
  (close)="selectClosed()"
  (scrollToEnd)="handleScrollToEnd()">

  @if (searchable) {
    <ng-template ng-header-tmp>
      <input
        type="text"
        class="input"
        [formControl]="searchControl"
        placeholder="{{'COMMON.search' | translate | titlecase }}"
        [attr.aria-label]="placeholder">
    </ng-template>
  }

  @if (multiple) {
    <ng-template ng-option-tmp let-item="item" let-index="index">
      <mat-checkbox class="ng-option-checkbox" color="primary" [checked]="selectControl.value && selectControl.value?.indexOf(item[bindValue] || item) !== -1">
        {{ item[bindLabel] || item }}
      </mat-checkbox>
    </ng-template>
    @if (showAddNewButton) {
      <ng-template ng-footer-tmp>
        <button mat-flat-button class="ng-footer-button" (click)="addTag()">
          {{ 'FORUM.add_tag' | translate : { tag: searchControl?.value } }}
        </button>
      </ng-template>
    }
    <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
      @for (item of items | slice:0:2; track item) {
        <div class="ng-value">
          <span class="ng-value-icon left" (click)="clear(item)" aria-hidden="true">×</span>
          <span class="ng-value-label">
            {{ item[bindLabel] || item }}
          </span>
        </div>
      }
      @if (items.length > 2) {
        <div class="ng-more-options">
          <span>+{{items.length -  2}}</span>
        </div>
      }
    </ng-template>
  }
</ng-select>
